export default "__VITE_ASSET__CDzs$jwn__"